import { render, staticRenderFns } from "./templateWorkflowDataList.vue?vue&type=template&id=5af2d9fc&scoped=true"
import script from "./templateWorkflowDataList.vue?vue&type=script&lang=js"
export * from "./templateWorkflowDataList.vue?vue&type=script&lang=js"
import style0 from "./templateWorkflowDataList.vue?vue&type=style&index=0&id=5af2d9fc&prod&scoped=true&lang=scss"
import style1 from "./templateWorkflowDataList.vue?vue&type=style&index=1&id=5af2d9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2d9fc",
  null
  
)

export default component.exports